import { dataHooks } from '@wix/data-hooks';

export const articleSearchResultItemDataHooks = dataHooks<{
  searchResultItemTimeToRead;
  searchResultItemDescription;
  searchResultItem;
  searchResultItemTitle;
  searchResultItemTitleLink;
}>('articleSearchResultItem');
